import { ReactElement } from 'react';
import { Component as CheckIcon } from 'icons/icon-ui--check.svg';
import styles from './PriceSummary.module.scss';

type Props = {
  couponAmount?: string;
  couponCode?: string;
};

export function CouponBanner({
  couponAmount,
  couponCode
}: Props): ReactElement {
  return (
    <div className={styles.coupon_text}>
      <CheckIcon width="15" height="15" />
      {' '}
      <b>{couponAmount}</b>
      {' '}
      &nbsp;
      {' '}
      {couponCode}
      {' '}
      Coupon Applied!
    </div>
  );
}
